/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-cycle */
import { createActions } from 'redux-actions';
import { ROOT_SLICE } from '../constants';

const {
	setSelectedItem,
	setSelectedItemChangesClone,
	setIsSavingEditedItem,
	setErrorMessageSaveEditedItem,
  
	setNewItem,
	setIsSavingNewItem,
  setErrorMessageSaveNewItem,
  
	setIsDeletingItem,
	setErrorMessageDeleteItem,
	setShowConfirmation,
  setConfirmationMessageKey,
  
  setShowValidation,

  reset,
} = createActions(
	{
		SET_SELECTED_ITEM: item => ({ item }),
		SET_SELECTED_ITEM_CHANGES_CLONE: clone => ({ clone }),
		SET_IS_SAVING_EDITED_ITEM: isSavingEditedItem => ({ isSavingEditedItem }),
		SET_ERROR_MESSAGE_SAVE_EDITED_ITEM: errorMessageSaveEditedItem => ({
			errorMessageSaveEditedItem
		}),

    SET_NEW_ITEM: newItem => ({ newItem }),
		SET_IS_SAVING_NEW_ITEM: isSavingNewItem => ({ isSavingNewItem }),
		SET_ERROR_MESSAGE_SAVE_NEW_ITEM: errorMessageSaveNewItem => ({
			errorMessageSaveNewItem
		}),

    SET_IS_DELETING_ITEM: isDeletingItem => ({
			isDeletingItem
		}),
		SET_ERROR_MESSAGE_DELETE_ITEM: errorMessageDeleteItem => ({
			errorMessageDeleteItem
		}),
		SET_SHOW_CONFIRMATION: showConfirmation => {
			return { showConfirmation };
		},
		SET_CONFIRMATION_MESSAGE_KEY: confirmationMessageKey => {
			return { confirmationMessageKey };
    },
    
    SET_SHOW_VALIDATION: show => ({ show }),

    RESET: () => ({}),
	},
	{ prefix: ROOT_SLICE }
);

export {
	setSelectedItem,
	setSelectedItemChangesClone,
	setIsSavingEditedItem,
	setErrorMessageSaveEditedItem,
  
	setNewItem,
	setIsSavingNewItem,
  setErrorMessageSaveNewItem,
  
	setIsDeletingItem,
	setErrorMessageDeleteItem,
	setShowConfirmation,
  setConfirmationMessageKey,
  
  setShowValidation,

  reset,
};
